<template>
  <div class="header">
    <div class="tab flex1 fx-j-c">
      <div style="width: 400px"></div>
      <HeaderTabs
        class="flex1 fx-j-c"
        :tab-list="tabList"
        :tab-path="tabPath"
        :wa-is-login="waIsLogin"
        :wa-badge-count="waBadgeCount"
        :email-badge-dot-visible="emailBadgeDotVisible"
        @tab-change="tabChange"
      />
      <div class="fx-j-e" style="width: 260px;align-items: center">
        <div
            class="dropdown-trigger"
            style="margin-right: 20px; position: relative;cursor: pointer"
            @click="drawer = true"
        >
          <img
              style="height: 35px; width: 35px"
              data-v-2b3b0c9a=""
              src="@/assets/chat.png"
              class="icon"
          />
          <span
              data-v-2b3b0c9a=""
              class="ant-badge"
              style="zoom: 0.8; position: absolute; top: 25px"
          ><a data-v-2b3b0c9a="" href="#"></a
          ><!----></span
          >
        </div>
        <HeaderChatDropdown
          v-if="!isProduction"
          ref="chatDropdownWrapRef"
          :visible="visible"
          @toggle-dropdown="toggleDropdown"
        />
        <HeaderNoticeDropdown
          ref="dropdownRef"
          :all-data-total="allDataTotal"
          :is-read-all-loading="isReadAllLoading"
          :result-target-data-list="resultTargetDataList"
          :all-new-data-is-loading="allNewDataIsLoading"
          @mark-all-read="handleClickIsRead"
          @change-page="changePage"
          @refresh-unreads="getUnReadsList"
          @close="closeDropdownRef"
          @view-all="toAllNotify"
        />
        <HeaderUserDropdown
          ref="userDropdownRef"
          :display-user-avatar="displayUserAvatar"
          :display-user-name="displayUserName"
          :user-info="userInfo"
          :show-resource-quota-entries="showResourceQuotaEntries"
          :is-enterprise-main-user="isEnterpriseMainUser"
          :is-normal-user="isNormalUser"
          :mail-work-position="mailWorkPosition"
          :space-size-format="spaceSizeFormat"
          :space-size="spaceSize"
          :user-data-information="userDataInformation"
          :is-vip-user="isVipUser"
          :badge-icon="badgeIcon"
          :account-list="accountList"
          :active-account-id="activeAccountId"
          :get-account-type-tag-text="getAccountTypeTagText"
          :get-account-type-tag-class="getAccountTypeTagClass"
          @go-to-user-center="goToUserCenter"
          @go-to-station="goToStation"
          @go-to-store-details="goToStoreDetails"
          @go-to-store-edm="goToStoreEDM"
          @go-to-store-ai="goToStoreAI"
          @handle-click-join-vip="handleClickJoinVip"
          @go-to-setting="goToSetting"
          @go-to-repair-order="goToRepairOrder"
          @handle-switch-account="handleSwitchAccount"
          @handle-login-more="handleLoginMore"
          @handle-logout-current="handleLogoutCurrent"
          @handle-logout-all="handleLogoutAll"
        />
        <div data-v-2b3b0c9a="" style="width: 50px"></div>
      </div>
    </div>
    <CreateTeamPop v-if="visitable" v-model="visitable" @close="close"/>
    <Dialog
        v-model="dialogVisibleTips"
        :title="$t('sys.team.info')"
        :width="'400'"
        :dialogVisible="dialogVisibleTips"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleTips = val)"
    >
      <template #content>
        <div class="inners_warning">
          <div>
            <el-icon style="font-size: 25px;color: #448ef7">
              <Warning/>
            </el-icon>
          </div>
          <div style="font-size: 14px;">{{ $t('common.p2h4') }}</div>
        </div>
      </template>
      <template #footer>
        <div class="setting_center">
          <el-button type="primary" @click="dialogVisibleTips = false">{{ $t('common.data.know') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>

  <!--  侧边栏 AI-->
  <el-drawer
      v-model="drawer"
      :size="'32%'"
      style="max-width: 800px !important;min-width: 450px !important;"
      :with-header="false"
      :modal-append-to-body="false"
      :modal="false"
      modal-class="chatAIDrawer"
      custom-class="custom-drawer"
      :mask-click-close="false"
  >
    <AICom @closeAIChat="handleClickCloseChat"/>
  </el-drawer>
</template>
<script>
import {computed, nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import {useStore} from "vuex";
import home from "@/assets/img/tab/home.png";
import homeB from "@/assets/img/tab/home-b.png";
import email from "@/assets/img/tab/email.png";
import emailB from "@/assets/img/tab/email-b.png";
import wechat from "@/assets/img/tab/wechat.jpg"
import wechatB from "@/assets/img/tab/wechatB.jpg"
import file from "@/assets/img/tab/file.png";
import fileB from "@/assets/img/tab/file-b.png";
import {useRoute, useRouter} from "vue-router";
import CreateTeamPop from "../DiaPops/CreateTeamPop.vue";
import Dialog from "@/components/Dialog.vue";
import HeaderTabs from "./components/HeaderTabs.vue";
import HeaderChatDropdown from "./components/HeaderChatDropdown.vue";
import HeaderNoticeDropdown from "./components/HeaderNoticeDropdown.vue";
import HeaderUserDropdown from "./components/HeaderUserDropdown.vue";

import {conMessage} from "@/utils/mes/messageMap";
import {ElMessage} from "element-plus";
import {spaceSizeFormat} from "../../utils/file";
import {i18n} from "@/lang";
import AICom from "@/components/AI/index.vue"
import {isEmpty} from "@/utils/mylodash";
import {Storage} from "@/utils/storage";
import _store from "store2";
import isVipIcon from '@/assets/usercenter/isvip.png'
import noVipIcon from '@/assets/usercenter/no_vip.png'
import {
  clearBrowserStorageWithBackup,
  getAccountScopedLocalStoragePrefixes,
  getDefaultPreservedLocalStorageKeys,
  resetWindowLevelAccountCache,
  restoreBrowserStorageBackup
} from "@/utils/accountCache";
import {resetRequestRuntimeCache} from "@/utils/request";
import {
  clearLoginRouteDraft,
  getLoginTypeByAccountType,
  getLastLoginAccountType,
  getRememberedAccountDraftById,
  getRememberedFormsSnapshot,
  isAccountSessionActive,
  markAllAccountSessionsLoggedOut,
  readAccountsState as readStoredAccountsState,
  removeAccountSession,
  splitEnterpriseAccount,
  touchRememberedLoginAccount,
  upsertAccountSession,
  writeAccountsState as writeStoredAccountsState,
  writeLoginRouteDraft,
} from "@/utils/loginAccountMemory";

const store = useStore();

export default {
  methods: {spaceSizeFormat},
  components: {
    Dialog,
    CreateTeamPop,
    AICom,
    HeaderTabs,
    HeaderChatDropdown,
    HeaderNoticeDropdown,
    HeaderUserDropdown,
  },
  setup() {
    const userInfo = computed(() => store.state.user.userInfo);
    const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
    const isEnterpriseChildUser = computed(() => store.getters["user/isEnterpriseChildUser"])
    const isNormalUser = computed(() => store.getters["user/isNormalUser"])
    // 工位信息
    const dialogVisibleTips = ref(false);
    const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const visitable = ref(false);
    // 是否是vip
    const isVip = computed(() => store.getters['user/isVipAccount'])
    const isVipUser = computed(() => store.getters['user/isVipUser'])
    // vip 类型
    const vipType = computed(() => userInfo.value.isVip)
    console.log(vipType, 'vipType')
    // 侧边栏 draw
    const drawer = ref(false)
    const teamList = computed(() => store.state.email.teamList);
    const teamId = computed(() => store.state.email.teamID)
    const tabPath = computed(() => {
      const path = route.path.split("/")[1];
      return `/${path}`;
    });

    const EMAIL_UNREAD_DOT_STORAGE_KEY = 'email_unread_dot'
    const EMAIL_WS_UNREAD_COUNT_STORAGE_KEY = 'email_ws_unread_count'
    const EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY = 'email_badge_last_seen_total'
    const emailUnreadDot = ref(false)
    const emailWsUnreadCount = ref(0)
    const emailBadgeLastSeenTotal = ref(0)
    
    // 获取当前用户ID用于区分不同账号的缓存（需要提前声明，因为下面的函数会用到）
    const getCurrentUserId = () => {
      try {
        const userId = userInfo.value?.id || userInfo.value?.userId
        return userId ? String(userId) : ''
      } catch (e) {
        return ''
      }
    }

    const badgeIcon = computed(() => {
      return isVip.value ? isVipIcon : noVipIcon
    })

    const readEmailUnreadDotCache = () => {
      try {
        return localStorage.getItem(EMAIL_UNREAD_DOT_STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    }

    const clearEmailUnreadDot = () => {
      emailUnreadDot.value = false
      try {
        localStorage.removeItem(EMAIL_UNREAD_DOT_STORAGE_KEY)
      } catch (e) {
      }
    }

    const readEmailWsUnreadCountCache = () => {
      try {
        const raw = localStorage.getItem(EMAIL_WS_UNREAD_COUNT_STORAGE_KEY)
        const n = Number(raw || 0)
        return Number.isFinite(n) ? n : 0
      } catch (e) {
        return 0
      }
    }

    const clearEmailWsUnreadCount = () => {
      emailWsUnreadCount.value = 0
      try {
        localStorage.removeItem(EMAIL_WS_UNREAD_COUNT_STORAGE_KEY)
      } catch (e) {
      }
    }

    const readEmailBadgeLastSeenTotalCache = () => {
      try {
        const userId = getCurrentUserId()
        if (!userId) return 0
        // 使用账号特定的 key
        const storageKey = `${EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY}_${userId}`
        const raw = localStorage.getItem(storageKey)
        const n = Number(raw || 0)
        return Number.isFinite(n) ? n : 0
      } catch (e) {
        return 0
      }
    }

    const writeEmailBadgeLastSeenTotalCache = (n) => {
      try {
        const userId = getCurrentUserId()
        if (!userId) return
        // 使用账号特定的 key
        const storageKey = `${EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY}_${userId}`
        localStorage.setItem(storageKey, String(Number(n || 0)))
      } catch (e) {
      }
    }

    const handleEmailUnreadDot = (event) => {
      const hasUnread = Boolean(event?.detail?.hasUnread)
      if (hasUnread) emailUnreadDot.value = true
    }

    const handleEmailWsUnreadCount = (event) => {
      const count = Number(event?.detail?.count ?? 0)
      emailWsUnreadCount.value = Number.isFinite(count) ? count : 0
    }

    const allTeamStatisticsList = computed(() => store.state.countshow?.allEmailList || [])
    const emailStatisticsCount = computed(() => {
      const list = Array.isArray(allTeamStatisticsList.value) ? allTeamStatisticsList.value : []
      const targetKeys = new Set(['unReadCount', 'auditCount', 'failCount', 'followCount', 'receiveCount'])
      return list
          .filter(it => it && targetKeys.has(it.key))
          .reduce((sum, it) => sum + Number(it.count || 0), 0)
    })

    const emailBadgeCurrentTotal = computed(() => {
      return Number(emailStatisticsCount.value || 0) + Number(emailWsUnreadCount.value || 0)
    })

    const emailHasBadgeDot = computed(() => {
      return Number(emailBadgeCurrentTotal.value || 0) > Number(emailBadgeLastSeenTotal.value || 0)
    })

    const teamSumDataLoading = computed(() => store.state.countshow?.teamSumDataLoading)
    const teamSumDataLoadedTeamId = computed(() => store.state.countshow?.teamSumDataLoadedTeamId)
    
    // 用于防止闪烁的稳定状态 - 使用 ref 而不是 computed
    const emailBadgeDotVisible = ref(false)
    
    // 计算是否应该显示红点（内部逻辑）
    const shouldShowBadgeDot = computed(() => {
      const curTeamId = teamId.value == null ? '' : String(teamId.value)
      if (!curTeamId) return false
      
      // 数据正在加载时，不改变状态
      if (teamSumDataLoading.value) return emailBadgeDotVisible.value
      
      // 检查数据是否已加载完成
      const isDataReady = !teamSumDataLoading.value && String(teamSumDataLoadedTeamId.value || '') === curTeamId
      if (!isDataReady) return emailBadgeDotVisible.value
      
      // 计算是否有新消息
      const hasBadgeDot = Number(emailBadgeCurrentTotal.value || 0) > Number(emailBadgeLastSeenTotal.value || 0)
      return hasBadgeDot
    })
    
    // 监听 shouldShowBadgeDot 的变化，只在非加载状态下更新显示状态
    watch(shouldShowBadgeDot, (newVal) => {
      if (!teamSumDataLoading.value) {
        console.log('[Email Badge] 更新红点状态:', newVal, {
          currentTotal: emailBadgeCurrentTotal.value,
          lastSeenTotal: emailBadgeLastSeenTotal.value,
          teamId: teamId.value,
          loadedTeamId: teamSumDataLoadedTeamId.value
        })
        emailBadgeDotVisible.value = newVal
      }
    })
    
    // 监听 emailBadgeCurrentTotal 的变化，实时更新
    watch(emailBadgeCurrentTotal, () => {
      if (!teamSumDataLoading.value) {
        const curTeamId = teamId.value == null ? '' : String(teamId.value)
        const isDataReady = curTeamId && String(teamSumDataLoadedTeamId.value || '') === curTeamId
        if (isDataReady) {
          const hasBadgeDot = Number(emailBadgeCurrentTotal.value || 0) > Number(emailBadgeLastSeenTotal.value || 0)
          console.log('[Email Badge] 总数变化，更新红点:', hasBadgeDot, {
            currentTotal: emailBadgeCurrentTotal.value,
            lastSeenTotal: emailBadgeLastSeenTotal.value
          })
          emailBadgeDotVisible.value = hasBadgeDot
        }
      }
    })

    const refreshTeamSumData = async (id) => {
      const cur = id == null ? '' : String(id)
      if (!cur) return
      try {
        store.commit('countshow/setTeamSumDataLoadedTeamId', '')
        store.commit('countshow/setTeamSumDataLoading', true)
      } catch (e) {
      }
      try {
        await store.dispatch('countshow/getTeamSumDataApis', {teamId: cur})
      } catch (e) {
      }
    }

    const waBadgeCount = ref(0)
    const WA_LOGIN_STORAGE_KEY = 'wa_login_user'
    const waIsLogin = ref(false)

    const showResourceQuotaEntries = ref(false)

    const checkWaIsLogin = () => {
      try {
        const userId = getCurrentUserId()
        if (!userId) {
          waIsLogin.value = false
          return
        }
        // 使用当前用户ID来获取对应的登录信息
        const storageKey = `${WA_LOGIN_STORAGE_KEY}_${userId}`
        const user = Storage.get(storageKey) || Storage.get(WA_LOGIN_STORAGE_KEY)
        const isLogin = !!(user && user.id && (user.name || user.pushName))
        waIsLogin.value = isLogin
        console.log(`[WA Login Check] userId=${userId}, storageKey=${storageKey}, isLogin=${isLogin}`, user)
      } catch (e) {
        waIsLogin.value = false
        console.error('[WA Login Check] 检查失败:', e)
      }
    }

    watch(waIsLogin, (val) => {
      if (!val) {
        waBadgeCount.value = 0
      }
    })

    // 移除 tabPath 的 watch，改为全局监听
    // watch(tabPath, () => {
    //   checkWaIsLogin()
    // })

    // 监听 WhatsApp 页面的登录状态变化
    // 当首次进入 /whatsapp/wahome 时，Home.vue 会在 getUserInfo 中设置 wa_login_user
    // 此时需要重新检查登录状态以显示 badge
    watch(() => tabPath.value === '/whatsapp', (isWhatsappPage) => {
      if (isWhatsappPage) {
        // 延迟检查，确保 Home.vue 的 getUserInfo 已经执行
        setTimeout(() => {
          checkWaIsLogin()
        }, 100)
      }
    })

    // 监听 teamId 变化，自动刷新团队统计数据
    watch(teamId, (newTeamId, oldTeamId) => {
      if (newTeamId && String(newTeamId) !== String(oldTeamId)) {
        refreshTeamSumData(newTeamId)
      }
    }, { immediate: false })
    
    // 监听用户ID变化（账号切换），重新加载邮件红点状态
    watch(() => userInfo.value?.id, (newUserId, oldUserId) => {
      const isAccountSwitch = oldUserId && newUserId && String(newUserId) !== String(oldUserId)
      const isInitialLoad = !oldUserId && newUserId
      
      if (isAccountSwitch || isInitialLoad) {
        if (isAccountSwitch) {
          console.log(`[Email Badge] 检测到账号切换: ${oldUserId} -> ${newUserId}`)
        } else {
          console.log(`[Email Badge] 初始加载用户: ${newUserId}`)
        }
        
        nextTick(() => {
          try {
            // 加载新账号的邮件红点状态
            const lastSeenTotal = readEmailBadgeLastSeenTotalCache()
            emailBadgeLastSeenTotal.value = lastSeenTotal
            
            console.log(`[Email Badge] 加载账号邮件红点状态: userId=${newUserId}, lastSeenTotal=${lastSeenTotal}`)
            
            // 重新计算红点显示状态
            const curTeamId = teamId.value == null ? '' : String(teamId.value)
            if (curTeamId) {
              refreshTeamSumData(curTeamId)
            }
          } catch (e) {
            console.error('[Email Badge] 加载账号邮件红点状态失败:', e)
          }
        })
      }
    }, { immediate: true })
    
    // 监听用户ID变化（账号切换），重新加载 WhatsApp 未读数和登录状态
    // 这个 watcher 会在任何路由下都生效，不仅限于 /whatsapp
    watch(() => userInfo.value?.id, (newUserId, oldUserId) => {
      // 首次加载或账号切换时触发
      const isAccountSwitch = oldUserId && newUserId && String(newUserId) !== String(oldUserId)
      const isInitialLoad = !oldUserId && newUserId
      
      if (isAccountSwitch || isInitialLoad) {
        if (isAccountSwitch) {
          console.log(`[WA Badge] 检测到账号切换: ${oldUserId} -> ${newUserId}`)
        } else {
          console.log(`[WA Badge] 初始加载用户: ${newUserId}`)
        }
        
        // 使用 nextTick 确保 userInfo 已经完全更新
        nextTick(() => {
          try {
            // 1. 检查新账号的 WhatsApp 登录状态（不依赖路由）
            checkWaIsLogin()
            
            // 2. 加载新账号的未读数缓存
            const cache = readWaUnreadCache()
            const total = Object.values(cache || {}).reduce((sum, v) => sum + Number(v || 0), 0)
            waBadgeCount.value = Number.isFinite(total) ? total : 0
            
            console.log(`[WA Badge] 加载账号数据完成: userId=${newUserId}, count=${waBadgeCount.value}, isLogin=${waIsLogin.value}`)
          } catch (e) {
            waBadgeCount.value = 0
            waIsLogin.value = false
            console.error('[WA Badge] 加载账号数据失败:', e)
          }
        })
      }
    }, { immediate: true })
    
    const readWaUnreadCache = () => {
      try {
        const userId = getCurrentUserId()
        if (!userId) return {}
        const storageKey = `wa_unread_map_${userId}`
        const raw = localStorage.getItem(storageKey)
        const parsed = raw ? JSON.parse(raw) : {}
        return parsed && typeof parsed === 'object' ? parsed : {}
      } catch (e) {
        return {}
      }
    }

    const writeWaUnreadCache = (cache) => {
      try {
        const userId = getCurrentUserId()
        if (!userId) return
        const storageKey = `wa_unread_map_${userId}`
        localStorage.setItem(storageKey, JSON.stringify(cache || {}))
      } catch (e) {
      }
    }

    const stripWaIdSuffix = (v) => {
      const s = String(v || '').trim()
      if (!s) return ''
      return s.replace(/@.*$/, '')
    }

    const isSameWaChat = (a, b) => {
      const x = String(a || '').trim()
      const y = String(b || '').trim()
      if (!x || !y) return false
      if (x === y) return true
      const bx = stripWaIdSuffix(x)
      const by = stripWaIdSuffix(y)
      if (bx && by && bx === by) return true
      if (bx) {
        if (`${bx}@c.us` === y || `${bx}@lid` === y || `${bx}@g.us` === y) return true
      }
      if (by) {
        if (`${by}@c.us` === x || `${by}@lid` === x || `${by}@g.us` === x) return true
      }
      return false
    }

    const getGlobalWaHandledMessageIds = () => {
      try {
        if (!window.__waHandledMessageIds) {
          window.__waHandledMessageIds = new Map()
        }
        return window.__waHandledMessageIds
      } catch (e) {
        return null
      }
    }

    const markWaMessageHandled = (messageId) => {
      const mid = String(messageId || '').trim()
      if (!mid) return false

      const STORAGE_KEY = 'wa_handled_message_ids'
      const TTL_MS = 10 * 60 * 1000
      const MAX = 300

      try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const arr = raw ? JSON.parse(raw) : []
        const now = Date.now()
        const next = Array.isArray(arr) ? arr.filter(it => it && typeof it.id === 'string' && typeof it.ts === 'number' && now - it.ts < TTL_MS) : []
        if (next.some(it => it.id === mid)) {
          return false
        }
        next.push({ id: mid, ts: now })
        if (next.length > MAX) {
          next.splice(0, next.length - MAX)
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      } catch (e) {
      }

      const map = getGlobalWaHandledMessageIds()
      if (!map || typeof map.has !== 'function') return true

      const now = Date.now()
      try {
        for (const [k, ts] of map.entries()) {
          if (typeof ts === 'number' && now - ts > 5 * 60 * 1000) {
            map.delete(k)
          }
        }
      } catch (e) {
      }

      if (map.has(mid)) return false
      map.set(mid, now)
      return true
    }

    const handleWaPushMessage = (event) => {
      console.log('[WA Badge] handleWaPushMessage 被调用', event?.detail)
      
      const detail = event?.detail || {}
      const hasMessageId = !!String(detail?.messageId || '').trim()

      if (hasMessageId) {
        const ok = markWaMessageHandled(detail?.messageId)
        if (!ok) {
          console.log('[WA Badge] 消息已处理过，跳过:', detail?.messageId)
          return
        }
      }

      const rawCount = Number(detail?.count ?? detail?.badgeCount)
      const providedCount = Number.isFinite(rawCount) ? rawCount : null

      if (!hasMessageId && typeof providedCount === 'number') {
        console.log('[WA Badge] 直接设置未读数:', providedCount)
        waBadgeCount.value = providedCount
        return
      }

      const inc = typeof providedCount === 'number' ? providedCount : 1

      try {
        const activeRoomId = String(window.__waActiveRoomId || '').trim()
        const from = String(detail?.from || detail?.fromJid || detail?.sender || detail?.chatFrom || '').trim()
        const pushedChatId = String(detail?.chatId || '').trim()
        const compareId = from || pushedChatId
        if (activeRoomId && compareId && isSameWaChat(compareId, activeRoomId)) {
          console.log('[WA Badge] 消息来自当前活跃聊天，跳过:', {activeRoomId, compareId})
          return
        }
      } catch (e) {
        console.error('[WA Badge] 检查活跃聊天失败:', e)
      }

      const prevCount = waBadgeCount.value
      waBadgeCount.value = Number(waBadgeCount.value || 0) + inc
      console.log(`[WA Badge] 未读数更新: ${prevCount} -> ${waBadgeCount.value} (增加 ${inc})`)

      const chatId = String(detail?.chatId || '').trim()
      if (chatId) {
        const cache = readWaUnreadCache()
        const prevChatCount = cache[chatId] || 0
        cache[chatId] = Number(cache[chatId] || 0) + inc
        writeWaUnreadCache(cache)
        console.log(`[WA Badge] 更新聊天未读数: chatId=${chatId}, ${prevChatCount} -> ${cache[chatId]}`)
      }
    }

    const handleWaUnreadTotal = (event) => {
      const total = Number(event?.detail?.total ?? event?.detail?.count ?? 0)
      const next = Number.isFinite(total) ? total : 0
      
      // 当收到未读总数事件时，检查登录状态
      // 这确保了首次进入 WhatsApp 页面时，如果 Home.vue 已经设置了登录信息，
      // Header 能够及时更新 waIsLogin 状态以显示 badge
      checkWaIsLogin()
      
      // 直接使用从 WhatsApp 页面收到的总数
      // Home.vue 会在清理缓存后再发送此事件，所以这里应该信任这个值
      waBadgeCount.value = next

      // 如果总数为 0，清理整个缓存
      if (next === 0) {
        try {
          const userId = getCurrentUserId()
          if (userId) {
            const storageKey = `wa_unread_map_${userId}`
            localStorage.removeItem(storageKey)
          }
        } catch (e) {
        }
      }
    }

    const retainGlobalEventListener = (key, eventName, handler) => {
      try {
        const k = `__global_listener_refs_${key}`
        const refs = Number(window[k] || 0)
        if (refs <= 0) {
          window.addEventListener(eventName, handler)
          window[k] = 1
        } else {
          window[k] = refs + 1
        }
      } catch (e) {
        try {
          window.addEventListener(eventName, handler)
        } catch (e2) {
        }
      }
    }

    const releaseGlobalEventListener = (key, eventName, handler) => {
      try {
        const k = `__global_listener_refs_${key}`
        const refs = Number(window[k] || 0)
        const next = refs - 1
        if (next <= 0) {
          window.removeEventListener(eventName, handler)
          window[k] = 0
        } else {
          window[k] = next
        }
      } catch (e) {
        try {
          window.removeEventListener(eventName, handler)
        } catch (e2) {
        }
      }
    }


    // 通知图标类型

    // heander 最新消息
    const newData = computed(() => store.state.message.newData)
    const resultTargetDataList = computed(() => {
      if (newData.value.length !== 0) {
        return conMessage(newData.value);
      } else {
        return newData.value;
      }
    })


    const visible = ref(false);
    const isProduction = process.env.NODE_ENV === "production";
    const dropdownRef = ref(null);

    const chatDropdownWrapRef = ref(null)

    const userDropdownRef = ref(null)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const accountsState = ref({
      accounts: [],
      currentToken: '',
      currentId: ''
    })

    const readAccountsState = () => readStoredAccountsState()
    const writeAccountsState = (next) => writeStoredAccountsState(next)

    const ensureAccountsFromCurrentLogin = () => {
      const normalizeToken = (raw) => {
        const s = String(raw || '')
        if (!s) return ''
        if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
          try {
            const parsed = JSON.parse(s)
            return String(parsed || '')
          } catch (e) {
            return s.slice(1, -1)
          }
        }
        return s
      }

      const curToken = normalizeToken(localStorage.getItem('token'))
      if (!curToken) return

      const id = String(userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account ?? '')
      if (!id) return
      if (id === '0' || id === 'undefined' || id === 'null') return
      const next = upsertAccountSession({
        id,
        token: curToken,
        userName: String(userInfo.value?.userName || ''),
        avatar: String(userInfo.value?.avatar || userInfo.value?.photoUrl || ''),
        account: String(userInfo.value?.account || ''),
        phone: String(userInfo.value?.phone || ''),
        accountType: userInfo.value?.accountType,
      })
      accountsState.value = next
    }

    const accountList = computed(() => {
      return Array.isArray(accountsState.value?.accounts) ? accountsState.value.accounts : []
    })

    const activeAccountId = computed(() => {
      return String(accountsState.value?.currentId || '')
    })

    const activeAccount = computed(() => {
      return accountList.value.find(it => String(it?.id || '') === activeAccountId.value) || null
    })

    const displayUserName = computed(() => {
      return activeAccount.value?.userName || userInfo.value?.userName || ''
    })

    const displayUserAvatar = computed(() => {
      return activeAccount.value?.avatar || userInfo.value?.avatar || ''
    })

    const clearAccountCachesOnSwitch = () => {
      const storageBackup = clearBrowserStorageWithBackup({
        preserveLocalKeys: [
          ...getDefaultPreservedLocalStorageKeys(),
          ACCOUNTS_STORAGE_KEY,
        ],
        preserveLocalPrefixes: getAccountScopedLocalStoragePrefixes(),
      })

      // 临时重置 Header 中的 WhatsApp 状态，等待 watcher 重新加载
      try {
        waBadgeCount.value = 0
        waIsLogin.value = false
        console.log('[Account Switch] 临时重置 WhatsApp 状态，等待重新加载')
      } catch (e) {
        console.error('[Account Switch] 重置 WhatsApp 状态失败:', e)
      }

      try {
        _store('nBarUnreadMailNum', 0)
      } catch (e) {
      }
      resetWindowLevelAccountCache()
      resetRequestRuntimeCache()
      restoreBrowserStorageBackup(storageBackup)
    }

    const hasPersonalRememberedDraft = (draft) => {
      return Boolean(String(draft?.account || '').trim())
    }

    const hasEnterpriseRememberedDraft = (draft) => {
      return Boolean(
        String(draft?.companyAccount || '').trim() ||
        String(draft?.account || '').trim()
      )
    }

    const createLoginRouteDraftForAccount = async (acc, options = {}) => {
      const targetLoginType = getLoginTypeByAccountType(acc?.accountType)
      const exactDraft = options.preferExactAccount === false
        ? null
        : await getRememberedAccountDraftById(acc?.id)
      const snapshot = await getRememberedFormsSnapshot()
      const fallbackPersonal = snapshot?.personal || {}
      const fallbackEnterprise = snapshot?.enterprise || {}

      const buildPersonalDraft = (sourceDraft) => ({
        accountId: String(sourceDraft?.id || sourceDraft?.accountId || acc?.id || ''),
        account: sourceDraft?.account || acc?.account || acc?.phone || '',
        password: sourceDraft?.password || '',
        phoneCode: sourceDraft?.phoneCode || '',
        zoneCode: sourceDraft?.zoneCode || '',
      })

      const buildEnterpriseDraft = (sourceDraft) => {
        const fallbackEnterpriseParts = splitEnterpriseAccount(
          sourceDraft?.account || acc?.account || ''
        )
        return {
          accountId: String(sourceDraft?.id || sourceDraft?.accountId || acc?.id || ''),
          account: sourceDraft?.account || acc?.account || '',
          companyAccount: sourceDraft?.companyAccount || fallbackEnterpriseParts.companyAccount || '',
          alias: sourceDraft?.alias || fallbackEnterpriseParts.alias || '',
          password: sourceDraft?.password || '',
        }
      }

      if (targetLoginType === '0') {
        const sourceDraft = exactDraft || (hasPersonalRememberedDraft(fallbackPersonal) ? fallbackPersonal : null)
        const enterpriseDraft = hasEnterpriseRememberedDraft(fallbackEnterprise) ? fallbackEnterprise : null
        return {
          mode: 'prefill',
          loginType: '0',
          rememberAccount: Boolean(sourceDraft),
          personal: buildPersonalDraft(sourceDraft),
          enterprise: enterpriseDraft ? buildEnterpriseDraft(enterpriseDraft) : {},
        }
      }

      const sourceDraft = exactDraft || (hasEnterpriseRememberedDraft(fallbackEnterprise) ? fallbackEnterprise : null)
      const personalDraft = hasPersonalRememberedDraft(fallbackPersonal) ? fallbackPersonal : null
      return {
        mode: 'prefill',
        loginType: '1',
        rememberAccount: Boolean(sourceDraft),
        personal: personalDraft ? buildPersonalDraft(personalDraft) : {},
        enterprise: buildEnterpriseDraft(sourceDraft),
      }
    }

    const handleSwitchAccount = async (acc) => {
      if (!acc || !acc.id) return
      if (String(acc.id) === String(activeAccountId.value || '')) {
        userDropdownRef.value?.closeSwitchAccountDropdown?.()
        userDropdownRef.value?.handleClose?.()
        return
      }
      if (!isAccountSessionActive(acc)) {
        touchRememberedLoginAccount({
          accountId: acc.id,
          accountType: acc.accountType,
        })
        writeLoginRouteDraft(await createLoginRouteDraftForAccount(acc))
        userDropdownRef.value?.closeSwitchAccountDropdown?.()
        userDropdownRef.value?.handleClose?.()
        await router.push({path: '/login', query: {force: '1'}})
        return
      }
      try {
        store.commit('system/setGlobalLoading', true)
      } catch (e) {
      }
      try {
        touchRememberedLoginAccount({
          accountId: acc.id,
          accountType: acc.accountType,
        })
        const next = readAccountsState() || { accounts: [], currentToken: '', currentId: '' }
        next.currentId = String(acc.id)
        next.currentToken = String(acc.token)
        accountsState.value = next
        writeAccountsState(next)
        
        // 先清除旧账号的缓存
        clearAccountCachesOnSwitch()
        
        // 然后更新 token 和 localStorage，确保刷新后能正确获取用户信息
        try {
          localStorage.setItem('token', String(acc.token))
        } catch (e) {
        }
        try {
          _store('token', String(acc.token))
        } catch (e) {
        }
        
        // 预先保存切换后的用户基本信息，避免刷新后 userId 为空
        try {
          const userInfoToSave = {
            id: acc.id,
            userName: acc.userName,
            avatar: acc.avatar,
            account: acc.account,
            phone: acc.phone,
            accountType: acc.accountType,
            token: acc.token
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfoToSave))
          _store('userInfo', userInfoToSave)
        } catch (e) {
          console.error('Failed to save userInfo during account switch', e)
        }
        try {
          sessionStorage.setItem('__pending_account_switch_loading__', '1')
        } catch (e) {
        }
        
        ElMessage.success(i18n.global.t('common.header.switched_to', {name: acc.userName || acc.name || ''}))
        userDropdownRef.value?.closeSwitchAccountDropdown?.()
        userDropdownRef.value?.handleClose?.()
        try {
          await nextTick()
          await new Promise((resolve) => requestAnimationFrame(() => resolve()))
          await new Promise((resolve) => requestAnimationFrame(() => resolve()))
          await new Promise((resolve) => window.setTimeout(resolve, 120))

          try {
            window.location.reload()
          } catch (e) {
            try {
              store.commit('system/setGlobalLoading', false)
            } catch (e) {
            }
            try {
              sessionStorage.removeItem('__pending_account_switch_loading__')
            } catch (e) {
            }
          }
        } catch (e) {
          try {
            store.commit('system/setGlobalLoading', false)
          } catch (e) {
          }
          try {
            sessionStorage.removeItem('__pending_account_switch_loading__')
          } catch (e) {
          }
        }
      } catch (e) {
        try {
          store.commit('system/setGlobalLoading', false)
        } catch (e) {
        }
        try {
          sessionStorage.removeItem('__pending_account_switch_loading__')
        } catch (e) {
        }
      }
    }

    const handleLoginMore = () => {
      userDropdownRef.value?.closeSwitchAccountDropdown?.()
      userDropdownRef.value?.handleClose?.()
      clearLoginRouteDraft()
      try {
        const routeInfo = router.resolve({path: '/login', query: {force: '1'}})
        window.open(routeInfo.href, '_blank')
      } catch (e) {
      }
    }

    const getAccountTypeTagText = (acc) => {
      const t = Number(acc?.accountType)
      if (t === 1) return i18n.global.t('common.header.account_type.personal')
      if (t === 2 || t === 3) return i18n.global.t('common.header.account_type.enterprise')
      return ''
    }

    const getAccountTypeTagClass = (acc) => {
      const t = Number(acc?.accountType)
      if (t === 1) return 'is-personal'
      if (t === 2 || t === 3) return 'is-enterprise'
      return ''
    }

    const handleLogoutCurrent = async () => {
      userDropdownRef.value?.closeLogoutDropdown?.()
      userDropdownRef.value?.handleClose?.()
      let shouldPreserveLoginRouteDraft = false
      try {
        const curId = String(accountsState.value?.currentId || '')
        if (curId) {
          const currentAccount = accountList.value.find(it => String(it?.id || '') === curId) || null
          // 先检查账号是否在 rememberedAccounts 中
          const rememberedDraft = await getRememberedAccountDraftById(curId)
          // 个人版/企业版分开判定：只看当前退出账号所属类型的 formMemory 是否还在
          const snapshot = await getRememberedFormsSnapshot()
          const curLoginType = getLoginTypeByAccountType(currentAccount?.accountType)
          const hasFormMemoryForType = curLoginType === '1'
            ? Boolean(
              String(snapshot?.enterprise?.companyAccount || '').trim() ||
              String(snapshot?.enterprise?.account || '').trim()
            )
            : Boolean(String(snapshot?.personal?.account || '').trim())

          // 账号虽在 rememberedAccounts 中，但该类型的 formMemory 已被清空，
          // 说明用户取消了该类型的“记住账号”，此时不应保留 loginRouteDraft
          if (rememberedDraft && currentAccount && hasFormMemoryForType) {
            writeLoginRouteDraft(await createLoginRouteDraftForAccount(currentAccount))
            shouldPreserveLoginRouteDraft = true
          } else {
            clearLoginRouteDraft()
          }
          accountsState.value = removeAccountSession(curId)
        }
      } catch (e) {
      }
      await handleLogout({
        preserveAccounts: true,
        preserveLoginRouteDraft: shouldPreserveLoginRouteDraft,
      })
    }

    const handleLogoutAll = async () => {
      try {
        // 清除所有账号的 WhatsApp 登录信息
        // 1. 清除通用 key
        localStorage.removeItem('wa_login_user')
        
        // 2. 清除所有账号特定的 key
        const accounts = accountsState.value?.accounts || []
        for (const acc of accounts) {
          const userId = acc?.id
          if (userId) {
            localStorage.removeItem(`wa_login_user_${userId}`)
            console.log(`[Logout All] 清除账号 WhatsApp 缓存: userId=${userId}`)
          }
        }
      } catch (e) {
        console.error('[Logout All] 清除 WhatsApp 缓存失败:', e)
      }
      try {
        accountsState.value = markAllAccountSessionsLoggedOut()
      } catch (e) {
      }
      clearLoginRouteDraft()
      userDropdownRef.value?.closeLogoutDropdown?.()
      userDropdownRef.value?.handleClose?.()
      await handleLogout({preserveAccounts: true})
    }

    function toggleDropdown(event) {
      console.log(111);
      visible.value = !visible.value;
      event.stopPropagation();
    }

    function handleClick() {
      visible.value = false;
    }


    const tabList = ref([
      {
        src: home,
        srcb: homeB,
        path: "/dashboard",
        query: {},
      },
      {
        src: email,
        srcb: emailB,
        path: `/email`,
        cacheName: "",
        query: {},
        params: {
          teamId: teamId.value,
        },
      },
      {
        src: file,
        srcb: fileB,
        path: "/cloud",
        cacheName: "",
        query: {},
        params: {pg: "f"},
      },
      {
        src: wechat,
        srcb: wechatB,
        path: "/whatsapp",
        cacheName: "",
        query: {},
        params: {pg: "f"}
      }
    ]);

    // 通知
    function toAllNotify() {
      closeDropdownRef()
      openNewTab('/notificationList/systemNotification')
    }

    const openNewTab = (path, query = {}) => {
      const routeInfo = router.resolve({path, query});
      window.open(routeInfo.href, '_blank');
    };

    const isReadAllLoading = ref(false)
    const handleClickIsRead = async () => {
      if (resultTargetDataList.value.length === 0) {
        ElMessage.warning(i18n.global.t('sys.notice.unread'));
        return
      }
      isReadAllLoading.value = true
      try {
        await store.dispatch("message/isReadAllApis")
        await store.dispatch("message/getUnReadMessageListApisDefault", {pageNo: 1, pageSize: 999})
        await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
        isReadAllLoading.value = false
      } catch (e) {
        isReadAllLoading.value = false
      }
    }

    // async function tabChange(item) {
    //   console.log('fff', item, item.path, isEnterpriseChildUser.value, teamList.value)
    //
    //   if (item.path === `/email` && isEnterpriseChildUser.value && teamList.value.length === 0) {
    //     dialogVisibleTips.value = true;
    //     return
    //   }
    //   if (item.path === `/email` && !isEnterpriseChildUser.value && teamList.value.length === 0) {
    //     visitable.value = true;
    //     return;
    //   }
    //   // 路由初始化控制
    //   if (item.path === `/email`) {
    //     // const targetRouter = localStorage.getItem('activeMenu') == null || localStorage.getItem("activeMenu") == "/email/account_setting" ? '/email/inbox' : localStorage.getItem('activeMenu')
    //
    //     //找到目标 团队 看是否已经失效
    //     const targetTeam = teamList.value.find(it => it.id === item.params.teamId) || {expireTime: null}
    //     console.log(targetTeam, 'fff')
    //     let targetRouter = `/email/inbox`
    //     const time = targetTeam.expireTime;
    //     if (time === null) {
    //       // 永久有效
    //       await store.commit("email/setShouldShowSideBar", true)
    //       targetRouter = `/email/inbox`
    //     } else {
    //       const timeTemp = new Date(time).getTime();
    //       const now = Date.now(); // 当前时间戳（毫秒）
    //
    //       if (timeTemp > now) {
    //         // 还在有效期内，正常处理
    //         await store.commit("email/setShouldShowSideBar", true)
    //         targetRouter = `/email/inbox`
    //       } else {
    //         // 已过期，无效
    //         await store.commit("email/setShouldShowSideBar", false)
    //         targetRouter = `/email/systemPrompt`
    //       }
    //     }
    //     console.log('targetRouter', targetRouter)
    //     router.replace(targetRouter);
    //   } else {
    //     router.replace(item.path);
    //   }
    //   // 更新权限
    //   await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
    // }

    async function tabChange(item) {
      console.log('fff', item, item.path, isEnterpriseChildUser.value, teamList.value);

      // ① 特殊场景拦截
      if (item.path === `/email`) {
        clearEmailUnreadDot()
        // 记录当前的总数，只有当总数增加时才显示红点
        writeEmailBadgeLastSeenTotalCache(emailBadgeCurrentTotal.value)
        emailBadgeLastSeenTotal.value = emailBadgeCurrentTotal.value
        
        if (isEnterpriseChildUser.value && teamList.value.length === 0) {
          dialogVisibleTips.value = true;
          return;
        }
        if (!isEnterpriseChildUser.value && teamList.value.length === 0) {
          visitable.value = true;
          return;
        }
      }

      // ② email 模块特殊路由处理
      if (item.path === `/email`) {
        const targetTeam = teamList.value.find(it => it.id === teamId.value);
        console.log(targetTeam, 'targetTeam')
        const targetRouter = getEmailTargetRoute(targetTeam);

        console.log('targetRouter', targetRouter);

        router.replace(targetRouter);
      } else {
        router.replace(item.path);
      }

      // ③ 刷新权限信息（放在路由跳转之后）
      try {
        await store.dispatch("user/checkUserInfoIsAdmin", {
          teamId: teamId.value,
        });
      } catch (error) {
        console.error("权限刷新失败:", error);
      }
    }


    /** ----------------------------
     * 抽离出：判断 email 模块跳转路径
     * ---------------------------- */
    function getEmailTargetRoute(targetTeam) {
      if (!targetTeam || targetTeam.expireTime == null) {
        // 没团队 || 永不过期
        store.commit("email/setShouldShowSideBar", true);
        return `/email/inbox`;
      }

      const expire = new Date(targetTeam.expireTime).getTime();
      const now = Date.now();

      if (expire > now) {
        // 有效期内
        store.commit("email/setShouldShowSideBar", true);
        return `/email/inbox`;
      } else {
        // 团队已过期
        store.commit("email/setShouldShowSideBar", false);
        return `/email/systemPrompt?teamId=${targetTeam.id}&workPositionId=${targetTeam.workPositionId}`;
      }
    }

    function close() {
      visitable.value = false;
    }

    const pageNo = ref(1);
    const pageSize = ref(5);

    const flagNumbers = computed(() => {
      if (newData.value.length > pageSize.value) {
        return allDataTotal.value
      } else {
        return newData.value.length
      }
    })

    const allDataTotal = computed(() => store.state.message.allNewData)
    const isBottom = ref(false)
    const allNewDataIsLoading = computed(() => store.state.message.allNewDataIsLoading)
    const changePage = async () => {
      const startIndex = (pageNo.value - 1) * pageSize.value; // 计算当前页的起始索引
      const endIndex = Math.min(startIndex + pageSize.value, allDataTotal.value); // 计算当前页的结束索引
      console.log(endIndex, allDataTotal.value, 'fff')
      if (endIndex >= allDataTotal.value) {
        // ElMessage.warning("已经到底了")
        isBottom.value = true;
        return
      }
      pageNo.value = pageNo.value + 1;
      // 需要更新数据
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
    }

    const getUnReadsList = async () => {
      pageNo.value = 1
      isBottom.value = false
      await store.commit("message/resetNewData", [])
      // 需要更新数据
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
    }

    const closeHandleClick = (e) => {
      try {
        const target = e?.target
        if (target && chatDropdownWrapRef.value && chatDropdownWrapRef.value.contains(target)) {
          return
        }
        visible.value = false
      } catch (e) {
      }
    }


    onMounted(async () => {
      await store.dispatch('email/getTeamList', {isUpdate: true})
      await store.dispatch("user/getPositionByLoginList");
      
      // 加载团队统计数据（用于 email 红点标记）
      if (teamId.value) {
        await refreshTeamSumData(teamId.value)
      }
      
      // 所有消息的
      // await store.dispatch("message/getMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
      // 获取最新未读消息
      // 展示数据即可
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
      console.log(route.path.split("/"), "route", tabPath);

      // 延迟读取 WhatsApp 未读数，确保 userInfo 已经加载完成
      const loadWaBadgeCount = () => {
        try {
          const cache = readWaUnreadCache()
          const total = Object.values(cache || {}).reduce((sum, v) => sum + Number(v || 0), 0)
          waBadgeCount.value = Number.isFinite(total) ? total : 0
          console.log('[WA Badge] 从缓存加载未读数:', waBadgeCount.value)
        } catch (e) {
          waBadgeCount.value = 0
          console.error('[WA Badge] 加载缓存失败:', e)
        }
      }
      
      // 立即尝试加载一次
      loadWaBadgeCount()
      
      // 如果 userInfo 还没有加载完成，延迟再次尝试
      if (!getCurrentUserId()) {
        await nextTick()
        setTimeout(() => {
          loadWaBadgeCount()
        }, 100)
      }

      // 先检查登录状态，确保后续处理缓冲消息时状态正确
      checkWaIsLogin()

      try {
        emailUnreadDot.value = readEmailUnreadDotCache()
      } catch (e) {
      }

      try {
        emailWsUnreadCount.value = readEmailWsUnreadCountCache()
      } catch (e) {
      }

      try {
        emailBadgeLastSeenTotal.value = readEmailBadgeLastSeenTotalCache()
      } catch (e) {
      }

      // 初始化红点稳定状态，避免闪烁
      // 从 localStorage 读取上次的统计数据，预先计算红点状态
      try {
        const cachedSumData = window.localStorage.getItem('sumData')
        if (cachedSumData) {
          const formatData = JSON.parse(cachedSumData)
          const targetKeys = new Set(['unReadCount', 'auditCount', 'failCount', 'followCount', 'receiveCount'])
          const cachedCount = Array.isArray(formatData) 
            ? formatData.filter(it => it && targetKeys.has(it.key)).reduce((sum, it) => sum + Number(it.count || 0), 0)
            : 0
          const cachedTotal = Number(cachedCount || 0) + Number(emailWsUnreadCount.value || 0)
          const cachedLastSeen = Number(emailBadgeLastSeenTotal.value || 0)
          const shouldShow = cachedTotal > cachedLastSeen
          emailBadgeDotVisible.value = shouldShow
          console.log('[Email Badge] 初始化红点状态:', shouldShow, {
            cachedTotal,
            cachedLastSeen,
            cachedCount,
            wsUnreadCount: emailWsUnreadCount.value
          })
        }
      } catch (e) {
        console.warn('初始化红点状态失败:', e)
      }

      // 先注册事件监听器
      try {
        retainGlobalEventListener('wa-push-message', 'wa-push-message', handleWaPushMessage)
        console.log('[WA Badge] 已注册 wa-push-message 事件监听器')
      } catch (e) {
        console.error('[WA Badge] 注册事件监听器失败:', e)
      }
      
      // 处理在 Header 组件挂载前收到的缓冲消息
      // 使用 nextTick 确保事件监听器已经完全注册
      await nextTick()
      try {
        if (window.__waMessageBuffer && Array.isArray(window.__waMessageBuffer)) {
          const bufferLength = window.__waMessageBuffer.length
          console.log(`[WA Badge] 开始处理 ${bufferLength} 条缓冲消息`)
          
          if (bufferLength > 0) {
            const now = Date.now()
            // 只处理最近 30 秒内的消息，避免处理过期消息
            const recentMessages = window.__waMessageBuffer.filter(msg => {
              return msg && (now - (msg.timestamp || 0)) < 30000
            })
            
            console.log(`[WA Badge] 过滤后剩余 ${recentMessages.length} 条有效消息`)
            
            recentMessages.forEach((msg, index) => {
              if (msg.type === 'wa-push-message' && msg.detail) {
                try {
                  console.log(`[WA Badge] 处理缓冲消息 ${index + 1}/${recentMessages.length}:`, msg.detail)
                  handleWaPushMessage({detail: msg.detail})
                } catch (e) {
                  console.error(`[WA Badge] 处理缓冲消息 ${index + 1} 失败:`, e)
                }
              }
            })
            
            console.log(`[WA Badge] 缓冲消息处理完成，当前未读数: ${waBadgeCount.value}`)
          }
          
          // 清空缓冲区
          window.__waMessageBuffer = []
        }
      } catch (e) {
        console.error('[WA Badge] 处理缓冲消息失败:', e)
      }

      try {
        window.addEventListener('email-unread-dot', handleEmailUnreadDot)
      } catch (e) {
      }

      try {
        window.addEventListener('email-ws-unread-count', handleEmailWsUnreadCount)
      } catch (e) {
      }

      try {
        retainGlobalEventListener('wa-unread-total', 'wa-unread-total', handleWaUnreadTotal)
      } catch (e) {
      }

      document.addEventListener('click', closeHandleClick, {
        capture: true
      })

      // 注意：不在这里更新 emailBadgeLastSeenTotal，而是在用户点击 /email 时更新
      // 这样可以确保只有当用户主动访问 /email 后，红点才会消失
      // 并且只有当总数增加时，红点才会重新出现
    })

    onMounted(() => {
      const st = readAccountsState()
      if (st) {
        accountsState.value = st
      }
      ensureAccountsFromCurrentLogin()
    })

    onUnmounted(() => {
      try {
        releaseGlobalEventListener('waPushMessage', 'waPushMessage', handleWaPushMessage)
        releaseGlobalEventListener('waUnreadTotal', 'waUnreadTotal', handleWaUnreadTotal)
        releaseGlobalEventListener('emailUnreadDot', 'emailUnreadDot', handleEmailUnreadDot)
        releaseGlobalEventListener('emailWsUnreadCount', 'emailWsUnreadCount', handleEmailWsUnreadCount)
      } catch (e) {
      }
      try {
        document.removeEventListener('click', closeHandleClick, {capture: true})
      } catch (e) {
      }
      
    })

    function goToUserCenter() {
      router.push('/personal/basic')
    }

    function goToStation() {
      if (isEnterpriseMainUser.value || isNormalUser.value) {
        router.push('/personal/station')
      }
    }

    function goToStoreDetails() {
      if (isNormalUser.value) {
        router.push('/personal/storeDetails')
      } else {
        router.push('/personal/basic?active=1')
      }
    }

    function goToStoreEDM() {
      if (isNormalUser.value) {
        router.push("/personal/edmDetails")
      } else {
        router.push('/personal/basic?active=2')
      }
    }

    function goToStoreAI() {
      if (isNormalUser.value) {
        router.push("/personal/aiDetails")
      } else {
        router.push('/personal/basic?active=3')
      }
    }

    function goToSetting() {
      router.push('/personal/security')
    }

    function goToRepairOrder() {
      router.push('/personal/repairOrder')
    }

    async function handleLogout({preserveAccounts = false, preserveLoginRouteDraft = false} = {}) {
      const backupAccounts = preserveAccounts ? (readAccountsState() || null) : null
      // 退出前先取出“最后一次成功登录的账号类型”，避免清空存储后取不到
      const lastLoginType = getLoginTypeByAccountType(
        getLastLoginAccountType() || userInfo.value?.accountType
      )
      await store.dispatch('user/UserQuit', {preserveLoginRouteDraft})
      await store.dispatch('chat/logout')
      if (preserveAccounts && backupAccounts) {
        try {
          writeAccountsState(backupAccounts)
          accountsState.value = backupAccounts
        } catch (e) {
        }
      }
      // 个人版/企业版退出后，登录页都需要定位到刚登录账号对应的 tab
      router.push({path: '/login', query: {loginType: lastLoginType}})
    }

    const spaceSize = computed(() => store.state.cloud.spaceSize)
    const userDataInformation = computed(() => store.state.cloud.userDataInformation)
    onMounted(async () => {
      if (isEmpty(spaceSize.value)) {
        await store.dispatch("cloud/queryByUserIdApis")
      }
    })

    const handleClickCloseChat = () => {
      drawer.value = false
    }

    const closeDropdownRef = () => {
      dropdownRef.value?.handleClose?.()
    }

    const formattedMessage = computed(() => {
      const message = i18n.global.t("common.person.remainG", {
        count: mailWorkPosition.value.freePosition
      })
      return message
    })

    const handleClickJoinVip = () => {
      if (isNormalUser.value) {
        router.push('/personal/basic')
      } else if (isEnterpriseMainUser.value) {
        router.push('/personal/qinfo')
      }
    }

    return {
      badgeIcon,
      isVipUser,
      userDataInformation,
      vipType,
      handleClickJoinVip,
      isVip,
      isEnterpriseMainUser,
      isNormalUser,
      userDropdownRef,
      accountList,
      activeAccountId,
      displayUserName,
      displayUserAvatar,
      handleSwitchAccount,
      handleLoginMore,
      getAccountTypeTagText,
      getAccountTypeTagClass,
      handleLogoutCurrent,
      handleLogoutAll,
      goToStoreAI,
      goToStoreEDM,
      formattedMessage,
      isReadAllLoading,
      closeDropdownRef,
      handleClickCloseChat,
      spaceSize,
      getUnReadsList,
      flagNumbers,
      allNewDataIsLoading,
      allDataTotal,
      isBottom,
      changePage,
      resultTargetDataList,
      newData,
      handleClickIsRead,
      tabList,
      tabPath,
      tabChange,
      teamId,
      close,
      visitable,
      goToUserCenter,
      goToStation,
      goToStoreDetails,
      goToSetting,
      goToRepairOrder,
      handleLogout,
      userInfo,
      mailWorkPosition,
      dialogVisibleTips,
      toAllNotify,
      dropdownRef,
      chatDropdownWrapRef,
      visible,
      handleClick,
      toggleDropdown,
      drawer,
      emailUnreadDot,
      emailWsUnreadCount,
      emailBadgeLastSeenTotal,
      emailHasBadgeDot,
      emailBadgeDotVisible,
      waIsLogin,
      waBadgeCount,
      showResourceQuotaEntries,
      isProduction,
    };
  },
};
</script>
<style lang="less" scoped>
@import "./less/Header.less";

.wa-tab-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
}

// WhatsApp badge 的徽章内容定位
.wa-tab-badge :deep(.el-badge__content) {
  position: absolute;
  top: -8px !important;
  right: -8px !important;
  transform: translateX(50%) translateY(-50%);
}

.email-tab-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
}

// Email badge wrapper - 新的包装器
.email-badge-wrapper {
  position: relative;
  display: inline-block;
  line-height: 0;
}

// Email badge 自定义红点
.email-badge-dot {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 13px;
  height: 13px;
  background-color: var(--el-color-danger);
  border-radius: 50%;
  border: 1px solid #fff;
}

.left_text {
  span {
    display: inherit;
    margin-right: 8px;

    img {
      text-align: center;
    }
  }
}

.right_text {
  display: flex;
  align-items: center;
}

.sp_out {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #eef1f3;
  position: relative;

  & > img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

:deep(.el-dropdown-menu__item) {
  transition: all .3s;
}

:deep(.el-dropdown-menu__item > .el-dropdown) {
  width: 100% !important;
}

:deep(.el-dropdown-menu__item > .el-dropdown > .el-dropdown__trigger) {
  width: 100% !important;
}

:deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  background: #f9f9f9;
  color: #121212;
  transition: all .3s;
}

:deep(.el-dropdown-menu__item:nth-of-type(4):not(.is-disabled):focus) {
  background: transparent !important;

}

.inners_warning {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;

  div {
    margin-left: 10px;
  }
}

.setting_center {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-avatar) {
  cursor: pointer;
  background: #f3f3f3 !important;
}

.texts {
  color: #000000 !important;
}

.inner_notify_box {
  width: 350px;
  padding: 0 20px;
  background: #fff;
}

.boxs {
  width: 350px;
  min-width: 350px;
  height: auto;
  max-height: 540px !important;

  .empty {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
  }

  .item_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    align-items: center;
    z-index: 9;
    bottom: 0px;
    width: 100%;
    background: white;
  }

  .tops_side {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px 15px;
    position: absolute;
    top: 0px;
    width: 100%;
    background: white;

    .top_message {
      font-size: 18px;
      line-height: 18px;
      font-weight: 600;
      color: #333;
    }
  }
}

.inner_boxs {
  min-height: 106px;
  margin-top: 50px;
  margin-bottom: 30px;
}


// 只对消息通知的 badge 应用特殊定位
.items_message :deep(.el-badge__content) {
  position: absolute;
  right: calc(-8px + var(--el-badge-size) / 2) !important;
  top: -40px !important;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  // background-color: var(--el-color-danger);
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 10px;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}


/* 定义淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  transform: translate(-50%, -10px);
  opacity: 0;
}

.fade-enter-to, .dropdown-leave-from {
  opacity: 1;
  transform: translate(-50%, 0);
}


.custom-drawer {
  pointer-events: none !important; /* 禁止抽屉整体的点击穿透 */
}

:deep(.dropdown-trigger) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.items_message {
  position: absolute;
  top: 36px;
  left: 48px;
}

:deep(.el-menu-item *) {
  vertical-align: middle !important;
}

.item_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: black;
}

.inner_box_vip {
  margin-top: 10px;
  padding: 6px;
  margin-bottom: 10px;
  height: max-content;
  width: 100%;
  background: #F4F5F7;

  & > span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
  }
}

.switch-account-wrapper {
  position: relative;
}


:global(.switch-account-popper) {
  border-radius: 8px;
  overflow: hidden;
}

:global(.switch-account-popper .el-dropdown-menu) {
  padding: 0;
}

:global(.switch-account-popper .switch-account-dropdown) {
  min-width: 260px;
  background: #fff;
  padding: 8px 0;
}

:global(.switch-account-popper .switch-account-dropdown-item) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
}

:global(.switch-account-popper .switch-account-dropdown-item:hover) {
  background: #f5f7fa;
}

:global(.switch-account-popper .switch-account-dropdown-left) {
  display: flex;
  align-items: center;
  gap: 10px;
}

:global(.switch-account-popper .switch-account-dropdown-text) {
  display: flex;
  flex-direction: column;
}

:global(.switch-account-popper .switch-account-dropdown-name) {
  font-size: 14px;
  color: #111;
  display: flex;
  align-items: center;
  gap: 6px;
}

:global(.switch-account-popper .switch-account-dropdown-name-text) {
  line-height: 1.2;
}

:global(.switch-account-popper .switch-account-dropdown-tag) {
  font-size: 12px;
  line-height: 16px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.65);
  background: rgba(0, 0, 0, 0.03);
  flex: 0 0 auto;
}

:global(.switch-account-popper .switch-account-dropdown-tag.is-personal) {
  border-color: rgba(47, 125, 255, 0.35);
  color: #2f7dff;
  background: rgba(47, 125, 255, 0.08);
}

:global(.switch-account-popper .switch-account-dropdown-tag.is-enterprise) {
  border-color: rgba(245, 108, 108, 0.35);
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.08);
}

:global(.switch-account-popper .switch-account-dropdown-sub) {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 2px;
}

:global(.switch-account-popper .switch-account-dropdown-right) {
  color: #2f7dff;
}

:global(.switch-account-popper .switch-account-dropdown-footer) {
  padding: 10px 12px;
  color: #2f7dff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

:global(.switch-account-popper .switch-account-dropdown-footer:hover) {
  background: #f5f7fa;
}

:global(.logout-popper) {
  border-radius: 8px;
  overflow: hidden;
}

:global(.logout-popper .el-dropdown-menu) {
  padding: 0;
}

:global(.logout-popper .logout-dropdown) {
  min-width: 220px;
  background: #fff;
  padding: 8px 0;
}

:global(.logout-popper .logout-dropdown-item) {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #111;
}

:global(.logout-popper .logout-dropdown-item:hover) {
  background: #f5f7fa;
}

:global(.user-dropdown-popper) {
  max-width: calc(100vw - 24px);
}

:global(.user-dropdown-popper .el-dropdown-menu) {
  width: 260px;
  max-width: calc(100vw - 24px);
  box-sizing: border-box;
}

:global(.user-dropdown-popper .inner_box_vip) {
  white-space: normal;
  word-break: break-word;
}

.vip-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.plus-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  line-height: 0;
  padding-bottom: 4px;
}

.plus-icon {
  width: 53px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 5px;
}
</style>
